import React, {FC} from 'react';

import QuestionText from '../../components/QuestionText';

const StepName: FC = () => <QuestionText field="fullName" />;

export default StepName;
